module.exports = __webpack_public_path__ + "img/replace.9eee193c.png";